import { State } from "data";
import { getFormProps } from "data/form/formSelectors";
import "url-search-params-polyfill";
import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	save as saveForm,
	close as closeForm,
	saveAndClose as saveClose,
	removeForm,
} from "data/form/formActions";
import CustomError from "lib/api/CustomError";

function useForm(fid: string) {
	// Redux action dispatcher
	const dispatch = useDispatch();

	// Get the form properties from redux
	const props = useSelector((state: State) => getFormProps(state, fid));

	const save = useCallback(async () => {
		dispatch(saveForm(fid));
	}, [dispatch, fid]);

	const close = useCallback(async () => {
		dispatch(closeForm(fid));
	}, [dispatch, fid]);

	const remove = useCallback(async () => {
		dispatch(removeForm(fid));
	}, [dispatch, fid]);

	const saveAndClose = useCallback(async () => {
		dispatch(saveClose(fid));
	}, [dispatch, fid]);

	const patching = useMemo(() => props.status === "UPDATING", [props.status]);

	const error = useMemo(() => {
		if (props.status === "ERROR") {
			return new CustomError({
				message: props.message,
			});
		}
	}, [props.message, props.status]);

	const canSave = useMemo(() => props.status === "READY", [props.status]);

	const canClose = useMemo(
		() => props.status === "READY" || props.status === "ERROR",
		[props.status]
	);

	return {
		ready: props.status === "READY" || props.status === "UPDATING",
		uuid: props.rootElement,
		label: props.label,
		error,
		save,
		patching,
		dirty: props.dirty,
		close,
		saveAndClose,
		status: props.status,
		remove,
		canSave,
		canClose,
		formLocation: props.formLocation,
	};
}

export default useForm;
